/* eslint-disable */
import React from 'react';
import SliderButton from './components/SliderButton';
import styles from './MethodSlider.module.css';
const PayMethodSlider = () => {
  const methods = [
    {
      "icon":"credit",
      "label":"Tarjeta",
      "type":"card"
    },
    {
      "icon":"cash",
      "label":"Efectivo",
      "type":"oxxo"
    },
    {
      "icon":"spei",
      "label":"Transferencia",
      "type":"spei"
    }
  ]
  return (
    <>
     <label className={styles.label}>¿Cómo deseas pagar?</label>
     <div className={styles.container}>
        {methods.map((method,index) => {
          return(
            <SliderButton 
              key={index}
              data={method}
              index={index}
            />
          )
        })}
      </div>
    </>
    )
};

export default PayMethodSlider;
